export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/10 py-10"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
          <div className="font-heading text-xs font-bold uppercase tracking-[0.25em]">
            <span className="text-gradient-gold">THE GOLD FX</span>
            <span className="ml-2 text-gray-500">© {new Date().getFullYear()}</span>
          </div>
          <div
            data-testid="footer-disclaimer"
            className="max-w-xl text-center font-body text-[11px] leading-relaxed text-gray-500 sm:text-right"
          >
            Il trading sui mercati finanziari comporta rischi. Le performance passate non garantiscono risultati futuri. Investi solo capitale che puoi permetterti di perdere.
          </div>
        </div>
      </div>
    </footer>
  );
}
